import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Layout from 'Components/Layout';
import PageHeader from 'Components/PageHeader/PageHeader';
import MergedContactsViewer from 'Components/Personal/MergedContactsViewer';

function MergedContacts({ profile, user }) {
  const { t } = useTranslation();
  const mergedContacts = profile?.mergedContacts || user?.mergedContacts || [];

  return (
    <Layout>
      <Helmet>
        <title>{t('Merged Contacts - HeresMyInfo.com')}</title>
      </Helmet>
      <PageHeader
        title={t('Merged Contacts')}
        description={t('History of contact merges performed during deduplication, showing the date and time of each merge.')}
      />
      <div style={{ padding: '20px' }}>
        <MergedContactsViewer mergedContacts={mergedContacts} />
      </div>
    </Layout>
  );
}

const mapStateToProps = state => ({
  profile: state.auth.currentUser?.profile,
  user: state.auth.currentUser
});

export default connect(mapStateToProps)(MergedContacts);
